/* eslint-disable import/prefer-default-export */
export const COURSE_UNIT_LIST = `
query($courseId: Int!, $type: String) {
  englishCourseUnitList(courseId: $courseId, type: $type) {
    id
    name
    status
    progress
    isExperience
  }
}`;

export const COURSE_MODULE_LIST = `
query($unitId: Int!) {
  englishCourseModuleList(unitId: $unitId) {
    name
    modeList {
      id
      name
      isFinished
      isCompleted
    }
  }
}`;

export const COURSE_DATA = `
query($modelId: Int, $type: String, $courseId: Int, $unitId: Int, $mode: String, $examType: String, $examMode: String){
  englishCourseData(modelId: $modelId, type: $type, courseId: $courseId, unitId: $unitId, mode: $mode, examType: $examType, examMode: $examMode){
    id
    type
    status
    navigation
    title
    subtitle
    description
    isBacktrack
    message
    playTimes
    bookMode
    quizzes{
      id
      code
      mode
      ... on EnglishCourseQuizQHLJ {
        image
        text
        explain
        fix {
          word
          tag
        }
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizDX {
        answer
        answerIndex
        question
        options
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizBQWZ {
        article
        extras
        parts {
          id
          answer
          parse {
            audio
            text
          }
        }
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizMED {
        duration
        items {
          id
          duration
          text
          explain
          audio
          image
        }
      }
      ... on EnglishCourseQuizKY {
        text
        audio
        beep
        image
        explain
      }
      ... on EnglishCourseQuizJXZH {
        question
        answer
        extras
        parse {
          audio
          text
        }
      }
      ... on EnglishCourseQuizTYLJ {
        text
        explain
        answer
        audio
        extras
      }
      ... on EnglishCourseQuizWK {
        video
        poster
        videoDone
        quizzes {
          question
          options
          answer
          type
          time
        }
      }
      ... on EnglishCourseQuizCHXZ {
        text
        explain
        audio
        options
        answer
        gameId
      }
      ... on EnglishCourseQuizDCTX {
        text
        explain
        audio
        gameId
      }
      ... on EnglishCourseQuizSK {
        text
        explain
        phonetic
        audio
        exampleSentence
        exampleExplain
        gameId
      }
      ... on EnglishCourseQuizHYDC {
        text
        explain
        audio
        gameId
      }
      ... on EnglishCourseQuizDCPX {
        text
        explain
        fixs
        audio
        gameId
      }
      ... on EnglishCourseQuizYDLJ {
        article
        parse {
          audio
          text
          imageList {
            name
            url
          }
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizWXTK {
        article
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizTHXZ {
        article
        audio
        playTimes
        parse {
          audio
          text
        }
        items {
          id
          text
          answer
          options
          parse {
            audio
            text
          }
        }
      }
      ... on EnglishCourseQuizXCTK {
        article
        extras
        parse {
          audio
          text
        }
        items {
          id
          answer
          parse {
            audio
            text
          }
        }
      }
    }
  }
}`;

export const EXAM_MODEL_LIST = `query ($courseId: Int, $unitId: Int) {
  englishExamModelList(courseId: $courseId, unitId: $unitId) {
    navigation
    title
    list {
      label
      value
      status
    }
  }
}`;

export const COURSE_RESULT = `
mutation ($id: Int, $courseId: Int, $unitId: Int, $moduleId: Int, $type: String, $mode: String, $quizzes: String!, $spend: String, $seconds: Int, $isBacktrack: Int) {
  englishCourseResult(id: $id, courseId: $courseId, unitId: $unitId, moduleId: $moduleId, type: $type, mode: $mode, quizzes: $quizzes, spend: $spend, seconds: $seconds, isBacktrack: $isBacktrack) {
    examId
    beforeExamId
    score
    progress
    isContinue
    bookReview
    message
    name
    schoolName
    bookName
    unitName
    wordCount
    time
  }
}`;

export const VERIFY_WRONG_WORD = `query ($courseId: Int) {
  verifyWrongWord(courseId: $courseId) {
    isHint
    count
  }
}`;

export const EXAM_ONLINE_MODEL_LIST = `query($type: String) {
  englishOnlineExamModelList(type: $type) {
    label
    value
  }
}`;

const QUIZZES_FRAGMENT = `
quizzes {
  id
  code
  mode
  ... on EnglishCourseQuizYDLJ {
    article
    parse {
      audio
      text
      imageList {
        name
        url
      }
    }
    items {
      id
      text
      answer
      options
      wrongAnswer
      parse {
        audio
        text
      }
    }
  }
  ... on EnglishCourseQuizCHXZ {
    text
    explain
    audio
    options
    answer
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizDCTX {
    text
    explain
    audio
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizSK {
    text
    explain
    phonetic
    audio
    exampleSentence
    exampleExplain
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizHYDC {
    text
    explain
    audio
    gameId
    userAnswer
  }
  ... on EnglishCourseQuizDCPX {
    text
    explain
    fixs
    audio
    gameId
    userAnswer
  }
}
`;

export const EXAM_DETAIL = `query($examId: Int, $type: String, $userId: String) {
  englishExamDetail(examId: $examId, type: $type, userId: $userId) {
    name
    courseName
    schoolName
    score
    wordCount
    time
    unitName
    qrcode
    ${QUIZZES_FRAGMENT}
  }
}`;

export const DIFF_EXAM_DETAIL = `
query(
  $beforeExamId: Int!
  $afterExamId: Int!
) {
  diffEnglishExamDetail(
    beforeExamId: $beforeExamId
    afterExamId: $afterExamId
  ) {
    navigation
    score
    ${QUIZZES_FRAGMENT}
  }
}`;

export const IAT_URL = `
  query {
    iatUrl
  }
`;

export const CHECK_MATCH = `
  query {
    checkMatch {
      id
      teacher
      url
    }
  }
`;
